module.exports = __webpack_public_path__ + "img/unverified.53b47b0c.png";